export default "__VITE_ASSET__1wxay0MV__"